module.exports = __webpack_public_path__ + "img/b02.a28aab69.png";